import { QueryClient } from '@tanstack/react-query';
import type { FixtureSearchQuery } from '@matchroom/shared';
import { queryConfig } from './config';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: queryConfig.staleTime,
      gcTime: queryConfig.gcTime,
      retry: queryConfig.retry,
      refetchOnWindowFocus: false,
    },
  },
});

export const queryKeys = {
  auth: {
    me: ['auth', 'me'] as const,
  },
  users: {
    all: ['users'] as const,
    profile: (username: string) => ['users', 'profile', username] as const,
    search: (q: string) => ['users', 'search', q] as const,
  },
  rooms: {
    all: ['rooms'] as const,
    detail: (id: string) => ['rooms', id] as const,
    byCode: (code: string) => ['rooms', 'code', code] as const,
  },
  matches: {
    all: ['matches'] as const,
    live: ['matches', 'live'] as const,
    upcoming: ['matches', 'upcoming'] as const,
    finished: ['matches', 'finished'] as const,
    popular: ['matches', 'popular'] as const,
    search: (params?: FixtureSearchQuery) =>
      ['matches', 'search', params] as const,
    detail: (id: string) => ['matches', id] as const,
    events: (id: string) => ['matches', id, 'events'] as const,
    statistics: (id: string) => ['matches', id, 'statistics'] as const,
    lineups: (id: string) => ['matches', id, 'lineups'] as const,
    teams: (search?: string) => ['matches', 'teams', search] as const,
    team: (id: string) => ['matches', 'team', id] as const,
    competitions: ['matches', 'competitions'] as const,
    competition: (slug: string) => ['matches', 'competition', slug] as const,
    standings: (slug: string) => ['matches', 'competition', slug, 'standings'] as const,
    roomFixture: (roomId: string) => ['matches', 'room', roomId, 'fixture'] as const,
  },
  chat: {
    messages: (roomId: string) => ['chat', roomId, 'messages'] as const,
  },
  friends: {
    all: ['friends'] as const,
    pending: ['friends', 'pending'] as const,
  },
  notifications: {
    all: ['notifications'] as const,
    unreadCount: ['notifications', 'unread-count'] as const,
  },
} as const;
